import { gql } from "@apollo/client";

const InterviewRequestFragment = gql`
  fragment InterviewRequestFields on InterviewRequest {
    id
    slug
    step
    canceled_at
    created_at
    interview_type
    confirmed_at
    start_time
    end_time
    duration
    time_zone
    transitions {
      id
      created_at
      from
      to
      event
      changed_details
      interview_type
      body
      start_time
      end_time
    }

    hangout_url
    zoom_url
    ms_teams_url
    preferred_phone
    skype_username
    bluejeans_meetingid
    onsite_location {
      street1
      street2
      city
      state
      postal_code
    }

    details_for_candidate
    details_for_employer
    interviewee
    cced_user_ids
    body
    from_name

    next_available_slot {
      start_time
      id
    }
    available_slots {
      start_time
      id
    }

    is_admin_manually_created
    ccedUsers {
      cronofyAuthToken {
        providerUid
      }
    }
  }
`;

export default InterviewRequestFragment;
